module.exports = __webpack_public_path__ + "static/media/right_align_02.93655c7f.jpeg";